import visually from './visually';
import click from './click';

// 自定义指令
const directives = {
    visually,
    click
};

export default {
    install(Vue) {
        Object.keys(directives).forEach(key => {
            Vue.directive(key, directives[key]);
        });
    }
};